import React from 'react';
import { Badge, Button } from 'react-bootstrap';

const FieldMappingsSideNav = ({ 
  categories, 
  activeSection, 
  setActiveSection,
  mappingStats
}) => {
  // Calculate if all fields are mapped
  const allFieldsMapped = Object.values(mappingStats).every(
    stats => stats.mapped === stats.total && stats.total > 0
  );

  // Map long category names to shorter versions
  const getShortenedCategoryName = (category) => {
    // Customize this based on your actual category names
    switch(category) {
      case 'Primary Contact':
        return 'Primary';
      case 'Contact Address':
        return 'Address';
      case 'Account Information':
        return 'Account';
      case 'Business Address':
        return 'Business';
      default:
        return category;
    }
  };

  return (
    <div className="side-navigation">
      {/* Brand Section */}
      <div className="brand-section">
        <h5 className="mb-0">Field Mappings</h5>
      </div>
      
      {/* Navigation Items */}
      <div className="nav-items">
        {categories.map((category, index) => {
          const stats = mappingStats[category] || { mapped: 0, total: 0 };
          const isComplete = stats.mapped === stats.total && stats.total > 0;
          const isActive = activeSection === index;
          
          return (
            <div 
              key={category}
              className={`nav-item ${isActive ? 'active-option2' : ''} ${isComplete ? 'completed' : ''}`}
              onClick={() => setActiveSection(index)}
              style={{ position: isActive ? 'relative' : 'static' }}
            >
              <div className="d-flex justify-content-between align-items-center w-100">
                <span>{category}</span>
                <span className={`count-text ${isComplete ? 'text-success' : ''}`}>
                  {stats.mapped}/{stats.total}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      
      
    </div>
  );
};

export default FieldMappingsSideNav;